export const parsePrice = (price) => {
  price = price.split(",").join("");
  const digitRegex = RegExp("^\\d+$");
  const zeroRegex = RegExp("^0+$");

  if (!price || price.length === 0 || !digitRegex.test(price)) return;

  const digitCount = price.length;
  let parsedPrice = "";

  if (digitCount >= 3) {
    const cents = price.slice(digitCount - 2);
    let real = price.slice(0, digitCount - 2);

    if (zeroRegex.test(real)) {
      real = "0";
    } else if (real[0] === "0") {
      real = real.slice(1);
    }

    parsedPrice = `${real},${cents}`;
  } else if (digitCount === 2) {
    parsedPrice = `0,${price}`;
  } else if (digitCount === 1) {
    parsedPrice = `0,0${price}`;
  }

  return parsedPrice;
};
